import { SYMBOL_ONLY, SYMBOL_VIEWBOX } from '@/components/brand/Logo'
import { Avatar } from '@/components/ui/avatar'

export function ChatBotAvatar() {
  return (
    <Avatar className="animate-brand-drift mb-2 size-10 items-center justify-center lg:size-8">
      <svg
        className="size-6 lg:size-5"
        viewBox={SYMBOL_VIEWBOX}
        role="img"
        aria-label="Cai"
        xmlns="http://www.w3.org/2000/svg"
      >
        {SYMBOL_ONLY.map((d) => (
          <path key={d} d={d} fill="white" />
        ))}
      </svg>
    </Avatar>
  )
}
